import { Component } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { CommonService } from "projects/services/src/app/API/nsdccommonService/common.service";

@Component({
  selector: "app-pmv-trades-resoureces",
  templateUrl: "./pmv-trades-resoureces.component.html",
  styleUrls: ["./pmv-trades-resoureces.component.css"],
})
export class PmvTradesResourecesComponent {
  trades: any;
  dataMessage: string;
  langaugecode: any;

  constructor(
    private commonservice: CommonService,
    private activeRoute: ActivatedRoute,
    public location: Location
  ) {}

  ngOnInit() {
    this.getTrades();
  }

  getTrades() {
    this.activeRoute.queryParams.subscribe((params) => {
      this.langaugecode = params.langcode;
    });

    let tradedata = JSON.parse(sessionStorage.getItem(this.langaugecode));

    if (tradedata) {
      this.trades = tradedata;
    } else {
      this.commonservice.getTrades(this.langaugecode).subscribe((res) => {
        if (res) {
          this.trades = res.trades;
          sessionStorage.setItem(this.langaugecode, JSON.stringify(res.trades));
        } else {
          this.dataMessage = "Data Not Found";
          console.log(this.dataMessage);
        }
      });
    }
  }

  back() {
    this.location.back();
  }
}
